module.exports = __webpack_public_path__ + "static/media/archway.10288a83.svg";